export const TimeKeepingVI = {
    "timeSheet": "Chấm công",
    "shiftSchedule": "Bảng phân ca",
    "shiftRegistrationTable":"Bảng đăng ký ca",
    "shiftAssignment": "Phân ca làm việc",
    "meals": "Bảng chấm công ăn",
    "leaveManagement": "Quản lý ngày nghỉ",
    "autoInout": "Tự động chấm công",
    "casualAndCompensatory": "Quản lý phép, bù",
    "casualLeave": "Quản lý phép",
    "compensatoryLeave": "Quản lý nghỉ bù"
}